<template>
  <vue-select
    v-bind="$attrs"
    v-on="$listeners"
    :placeholder="placeholder"
    append-to-body
    :calculate-position="withPopper"
    :class="{ 'vs--has-value': $attrs.value || $attrs.value && $attrs.value.length }"
  >
    <template #open-indicator="{ attributes }">
      <span v-bind="attributes">
        <svg-icon name="chevron-down" />
      </span>
    </template>
    <template #selected-option="{ label }">
      <span v-html="label" />
    </template>
    <template #option="{ label }">
      <span v-html="label" />
    </template>
  </vue-select>
</template>
<script>
import vSelect from "vue-select";
import { createPopper } from '@popperjs/core';

export default {
  name: 'Select',
  components: {
    'vue-select': vSelect
  },
  props: {
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      placement: 'bottom'
    }
  },
  methods: {
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        strategy: 'fixed',
        modifiers: [
          {
            name: 'offset', 
            options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({state}) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          }]
      });

      return () => popper.destroy();
    }
  }
}
</script>